import { Route } from 'src/routes/Route'

export const PromoRoute = Route({
  path: '/promo',
})

export type PromoRoute = Route<typeof PromoRoute>
